import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {RequestParameters} from '../shared/models/request-parameters/parameter.model';
import {Observable} from 'rxjs/Observable';

import {GlobalVariable} from '../global';
import {Organization} from './organization.model';
import {Subject} from 'rxjs/Subject';

import { OrganizationBankAccount } from './organization-bank.model';

@Injectable()
export class OrganizationService {
  private subject = new Subject<any>();
  constructor(private http: HttpClient) {
  }

  getOrganizationBankAccounts(parameters: RequestParameters = new RequestParameters()) {
    return this.http.get(GlobalVariable.BASE_API_URL + '/organization_bank/banks', {
      params: parameters.getHttpParams(),
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message
          });
        }
      );

  }

  postOrganizationBankAccount(organizationBankAccount: OrganizationBankAccount) {

    const body = this.normalizeOrganizationBankAccountData(organizationBankAccount);

    return this.http.post(GlobalVariable.BASE_API_URL + '/organization_bank/banks', body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }

  putOrganizationBankAccount(organizationBankAccount: OrganizationBankAccount) {

    const body = this.normalizeOrganizationBankAccountData(organizationBankAccount);

    return this.http.put(GlobalVariable.BASE_API_URL + '/organization_bank/bank/' 
    + organizationBankAccount.reference , body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );

  }

  disableOrganizationBankAccount(organizationBankAccount: OrganizationBankAccount, stateToApply) {
    return this.http.get(GlobalVariable.BASE_API_URL + '/organization_bank/bank/' + organizationBankAccount.reference + '/' + stateToApply)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch((error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }


  getOrganizations (parameters: RequestParameters = new RequestParameters()) {

    return this.http.get(GlobalVariable.BASE_API_URL + '/organizations', {
      params: parameters.getHttpParams(),
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message
          });
        }
      );

  }

  getOrganization (reference: string) {

    return this.http.get(GlobalVariable.BASE_API_URL + '/organization/' + reference, {
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message
          });
        }
      );

  }

  postOrganization (organization: Organization) {

    const body = this.normalizeOrganizationData(organization);

    return this.http.post(GlobalVariable.BASE_API_URL + '/organizations', body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }

  putOrganization (organization: Organization) {

    const body = this.normalizeOrganizationData(organization);

    return this.http.patch(GlobalVariable.BASE_API_URL + '/organization/' + organization.reference, body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );

  }

  deleteOrganization (organization: Organization) {
    return this.http.delete(GlobalVariable.BASE_API_URL + '/organization/' + organization.reference)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }
  disableOrganization(organization: Organization, stateToApply) {
    return this.http.get(GlobalVariable.BASE_API_URL + '/organization/' + organization.reference + '/' + stateToApply)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }

  private normalizeOrganizationData(organization: Organization): Organization {
    const body = Object.assign({}, organization);
    delete body.reference;
    delete body.depositAccount;
    if (body.media !== null) {
      body.media = body.media.reference;
    }
    if (body.country !== null) {
      body.country = body.country.reference;
    }
    if (body.manager !== null) {
      body.manager = body.manager.reference;
    }
    if (body.parent !== null) {
      body.parent = body.parent.reference;
    }

    return body;
  }

  private normalizeOrganizationBankAccountData(organizationBankAccount: OrganizationBankAccount): OrganizationBankAccount {
    const body = Object.assign({}, organizationBankAccount);
    delete body.reference;
    return body;
  }

  emitMessage(msg: object) {
    this.subject.next(msg);
  }
  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }

}


// WEBPACK FOOTER //
// ./src/app/organization/organization.service.ts